import { Badge } from "@/components/ui/badge";
import { TooltipWrapper } from "@/components/ui/TooltipWrapper";
import { cn } from "@/lib/utils";
import { VariantProps } from "class-variance-authority";
import { badgeVariants } from "@/components/ui/badge";

type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];

interface StateConfig {
  variant: BadgeVariant;
  label: string;
  tooltip?: string;
}

const statusMap: Record<string, StateConfig> = {
  'order_queue': {
    variant: "secondary",
    label: "Programado",
    tooltip: "",
  },
  'processing_queue': {
    variant: "Pendente",
    label: "Em processamento",
    tooltip: "",
  },
  'created': {
    variant: "Criado",
    label: "Criado",
    tooltip: "",
  },
  'Criado': {
    variant: "Criado",
    label: "Criado",
    tooltip: "",
  },
  'Pendente': {
    variant: "Pendente",
    label: "Pendente",
    tooltip: "",
  },
  'PortalB2BDone': {
    variant: "Pendente",
    label: "Processando",
    tooltip: "",
  },
  'pending': {
    variant: "pending",
    label: "Aguardando confirmação",
    tooltip: "",
  },
  'pending_confirmation': {
    variant: "pending",
    label: "Aguardando confirmação",
    tooltip: "",
  },
  'processing': {
    variant: "Processando",
    label: "Processando",
    tooltip: "",
  },
  'processed': {
    variant: "Processado",
    label: "Processado",
    tooltip: "",
  },
  'Processado': {
    variant: "Processado",
    label: "Processado",
    tooltip: "",
  },
  'failed': {
    variant: "destructive",
    label: "Falhou",
    tooltip: "",
  },
  'canceled': {
    variant: "Cancelado",
    label: "Cancelado",
    tooltip: "",
  },
  'entregue': {
    variant: "Entregue",
    label: "Entregue",
    tooltip: "",
  },
  'completed': {
    variant: "Entregue",
    label: "Entregue",
    tooltip: "",
  },
  'Entregue': {
    variant: "Entregue",
    label: "Entregue",
    tooltip: "",
  },
  'confirmed': {
    variant: "Faturado",
    label: "Confirmado",
    tooltip: "",
  },
  'Confirmado': {
    variant: "Faturado",
    label: "Confirmado",
    tooltip: "",
  },
  'cancelled': {
    variant: "Cancelado",
    label: "Cancelado",
    tooltip: "",
  },
  'Cancelado': {
    variant: "Cancelado",
    label: "Cancelado",
    tooltip: "",
  },
  'Em Rota': {
    variant: "Em Rota",
    label: "Em Rota",
    tooltip: "",
  }
};

/** Rótulo exibido para o status — o mesmo texto que o badge mostra na tela. */
export const getStatusLabel = (status: string) => statusMap[status]?.label ?? status;

interface StateBadgeProps {
  status: string;
  label?: string;
  tooltip?: string;
  className?: string;
}

const StateBadge = ({ status, label, tooltip, className }: StateBadgeProps) => {
  const config = statusMap[status] || {
    variant: "outline",
    label: status,
  };

  const displayLabel = label || config.label;
  const displayTooltip = tooltip || config.tooltip;

  const badge = (
    <Badge
      variant={config.variant as any}
      className={cn("whitespace-nowrap flex items-center gap-1 w-fit", className)}
    >
      {displayLabel}
    </Badge>
  );

  if (displayTooltip) {
    return <TooltipWrapper content={displayTooltip}>{badge}</TooltipWrapper>;
  }

  return badge;
};

export default StateBadge;
